"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceiptType = exports.ReceiptSource = void 0;
var ReceiptSource;
(function (ReceiptSource) {
    ReceiptSource["APP_SHARE"] = "APP_SHARE";
    ReceiptSource["BOLT"] = "BOLT";
    ReceiptSource["EMAIL_FETCHING"] = "EMAIL_FETCHING";
    ReceiptSource["EMAIL_FETCHING_BATCHED"] = "EMAIL_FETCHING_BATCHED";
    ReceiptSource["EMAIL_FORWARDING"] = "EMAIL_FORWARDING";
    ReceiptSource["GENERATED_RECEIPT"] = "GENERATED_RECEIPT";
    ReceiptSource["STOREBOX"] = "STOREBOX";
    ReceiptSource["TRAVELPERK"] = "TRAVELPERK";
    ReceiptSource["USER"] = "USER";
    ReceiptSource["CAMERA"] = "CAMERA";
    ReceiptSource["STRIPE"] = "STRIPE";
    ReceiptSource["LOST_RECEIPT"] = "LOST_RECEIPT";
    ReceiptSource["ROGER"] = "ROGER";
    ReceiptSource["CASHBACK"] = "CASHBACK";
})(ReceiptSource = exports.ReceiptSource || (exports.ReceiptSource = {}));
var ReceiptType;
(function (ReceiptType) {
    ReceiptType["EMBED"] = "embed";
    ReceiptType["ORIGINAL"] = "original";
    ReceiptType["THUMBNAIL"] = "thumbnail";
    ReceiptType["FILE"] = "file";
})(ReceiptType = exports.ReceiptType || (exports.ReceiptType = {}));
//# sourceMappingURL=receipt.js.map